import React from 'react';
import { motion } from 'framer-motion';
import { lenses, propositionNote } from '../data/portfolio';
import { Label } from './Label';
export function Proposition() {
  return <section id="proposition" aria-labelledby="proposition-heading" className="scroll-mt-20 bg-ink-900 px-6 py-24 md:px-10 md:py-32" data-id="element-159" data-mp="2y5m0j6yyf4o0">
      <div className="mx-auto w-full max-w-edge" data-id="element-160" data-mp="2t5znoyn1fqfq">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-161" data-mp="2p4nygu82t782">
          <div className="lg:col-span-4" data-id="element-162" data-mp="2p68qac30ac28">
            <Label data-id="element-163" data-mp="2keh9uudkdmpt">The Proposition</Label>
          </div>
          <div className="lg:col-span-8" data-id="element-164" data-mp="2kcwh9aat8dul">
            <h2 id="proposition-heading" className="font-display text-3xl font-normal leading-[1.2] text-paper md:text-[2.75rem] md:leading-[1.16]" data-id="element-165" data-mp="2feuuaea9judu">
              Three perspectives on the same table — an operator who has built technology, an
              investor who has priced it, and a director accountable for it.
            </h2>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-stone md:text-lg" data-id="element-166" data-mp="21hpkq4bccddu">
              {propositionNote}
            </p>
          </div>
        </div>

        {/* Three lenses, converging into board judgement */}
        <div className="mt-20 border-t border-white/15 md:mt-24" data-id="element-167" data-mp="3upbanf9qb62a">
          <ol className="grid md:grid-cols-3" data-id="element-168" data-mp="3umymulhai1hb">
            {lenses.map((lens, index) => <motion.li key={lens.label} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1],
            delay: index * 0.05
          }} className="relative border-b border-white/10 px-0 py-10 md:border-b-0 md:border-r md:px-8 md:py-12 md:first:pl-0 md:last:border-r-0 md:last:pr-0" data-id="element-169" data-mp="3g5mfjubm6du" data-mpi={index}>
                <span className="absolute -top-[5px] left-0 h-2.5 w-2.5 rounded-full bg-mint" aria-hidden="true" data-id="element-170" data-mp="32zq4am8i0n9t" />
                <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-brass" data-id="element-171" data-mp="1dfgjbo6ww8da">
                  {lens.label}
                </p>
                <p className="mt-6 font-display text-2xl font-normal leading-[1.28] text-paper" data-id="element-172" data-mp="18jrep6g1c1a4">
                  {lens.statement}
                </p>
                <p className="mt-5 text-[0.95rem] leading-relaxed text-stone" data-id="element-173" data-mp="yqk85i9k6f8g">{lens.detail}</p>
              </motion.li>)}
          </ol>

          <div className="grid md:grid-cols-3" aria-hidden="true" data-id="element-174" data-mp="unnqbtruen5k">
            {lenses.map(lens => <div key={lens.label} className="hidden justify-center md:flex" data-id="element-175" data-mp="krufcetrv1pw">
                <span className="h-16 w-px bg-white/15" data-id="element-176" data-mp="ktx46vj6uot1" />
              </div>)}
          </div>

          <div className="relative border-t border-white/15 pt-14 text-center" data-id="element-177" data-mp="fv40tvxm8e6l">
            <span className="absolute left-1/2 top-0 hidden h-10 w-px -translate-x-1/2 bg-mint md:block" aria-hidden="true" data-id="element-178" data-mp="2f52bc9thhjd4" />
            <p className="text-[11px] font-medium uppercase tracking-[0.34em] text-brass" data-id="element-179" data-mp="2imq3y6mc4jmp">
              Converging in
            </p>
            <p className="text-gradient mt-5 font-display text-4xl font-normal leading-tight md:text-6xl" data-id="element-180" data-mp="2mnjnyownpeab">
              Board judgement
            </p>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-stone" data-id="element-181" data-mp="2wffp68u1hkir">
              Technology understood, capital tested and governance owned — applied together in the
              boardroom.
            </p>
          </div>
        </div>
      </div>
    </section>;
}